import { Box, Button, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import Alert from '/@/components/bayer/alert';
import ModalV2 from '/@/components/bayer/modal-v2';
import Markdown from '/@/components/markdown';
import { useUserUIAlertAndModal } from '/@/hooks/ui/user-ui-alert-and-modal';
import { _ } from '/@/locale';

const UserUIAlertAndModal = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const query = useUserUIAlertAndModal();

    if (query.isLoading || !query.data?.length) return null;

    const activeItem = openIndex !== null && query.data[openIndex] !== undefined ? query.data[openIndex] : null;
    const modalOpen = activeItem !== null;

    return (
        <>
            {query.data.map((item, index) => (
                <Alert
                    severity={item.alertSeverity ?? 'blue'}
                    sx={{ alignItems: 'center', my: 1 }}
                    key={item.id}
                    actions={[
                        {
                            label: _('Ver más'),
                            onClick: () => setOpenIndex(index),
                            kind: 'link',
                        },
                    ]}
                >
                    <Typography>{_(item.alertTitle)}</Typography>
                </Alert>
            ))}
            <ModalV2
                open={modalOpen}
                onClose={() => setOpenIndex(null)}
                title={activeItem ? _(activeItem.modalTitle) : ''}
                maxWidth='md'
                actions={
                    <Button variant='text' color='secondary' onClick={() => setOpenIndex(null)}>
                        {_('Entendido')}
                    </Button>
                }
                actionsProps={{
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                }}
            >
                <Stack sx={{ px: 4 }}>
                    <Markdown
                        components={{
                            img: ({ src, alt }) => (
                                <Box
                                    component='img'
                                    src={src}
                                    alt={alt}
                                    sx={{
                                        maxWidth: '800px !important',
                                        width: 'auto',
                                        height: 'auto',
                                        display: 'block',
                                        margin: '1em 0',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        mx: 'auto',
                                    }}
                                />
                            ),
                        }}
                    >
                        {activeItem ? (_(activeItem.modalDescription) ?? '') : ''}
                    </Markdown>
                </Stack>
            </ModalV2>
        </>
    );
};
export default UserUIAlertAndModal;
